import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";

import Game from "../views/Game.vue";
import Leaderboard from "../views/Leaderboard.vue";
import Splash from "../views/Splash.vue";
import Results from "../views/Results.vue";
import Comments from "../views/Feed.vue";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "Splash",
    component: Splash,
  },
  {
    path: "/game",
    name: "Game",
    component: Game,
  },
  {
    path: "/results",
    name: "Results",
    component: Results,
  },
  {
    path: "/leaderboard",
    name: "Leaderboard",
    component: Leaderboard,
  },
  {
    path: "/feed",
    name: "Comments",
    component: Comments,
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
